import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

import ApproverSeePage from "./ApproverSubmittedSee";

import { GET_APPROVER_ACCEPTED_CI, } from "../../AppConstant";

function ApproverAccepted({ userDetails, setParentLoading }) {

    const [isApproved, setIsApproved] = useState(false); 
    const [submitted, setSubmitted] = useState([]);

    const [showSeeModal, setShowSeeModal] = useState(false);

    const getSubmitted = async () => {

        try {
            setParentLoading(true);
            const emailid = localStorage.getItem("emailid");

            const res = await axios.get(GET_APPROVER_ACCEPTED_CI, {
                params: { "approveremail": emailid }
            });
            setSubmitted(res.data);
            console.log("API response:", res.data);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    const handleOpenSeeModal = async (item) => {
        localStorage.setItem('swipexid', item.id)
        localStorage.setItem('swipexempid', item.empid)

        if(item.isapproverapproved == "approved" || item.isapproverapproved == "rejected"  || item.status == "F" || item.status == "A" || item.status == "U"){
            setIsApproved(true);
        }else{
            setIsApproved(false);
        }

        setParentLoading(true);
        setShowSeeModal(true);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseSeeModal = () => {
        setParentLoading(true);
        setShowSeeModal(false);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    useEffect(() => {
        getSubmitted();
    }, []);

    const [searchTerm, setSearchTerm] = useState("");
        
            const filteredRecords = submitted.filter((item) => {
            const searchableText = [
                ...Object.values(item),
            ]
                .join(" ")
                .toLowerCase();
        
            return searchableText.includes(searchTerm.toLowerCase());
        });

         const [expandedComment, setExpandedComment] = useState(null);
                                
                                const handleSeeMore = (index) => {
                                  setExpandedComment(expandedComment === index ? null : index);
                                };

    return (
        <div>

<div className="input-group mb-3" style={{ width: "500px" }}>
    <span className="input-group-text">
        <i className="bi bi-search"></i>
    </span>

    <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
    />
</div>

             <table className="mt-1 fw-bold" style={{fontSize:"small"}}>
                <thead className="bg-success-subtle" style={{ width:"100%", color:"green" }} >
                    <tr style={{width:"3%"}}>
                        <th style={{width:"5%"}}>S.No</th>
                        <th style={{width:"10%"}}>SWIPEX ID</th>
                        <th style={{width:"10%"}}>EMPLOYEE ID</th>
                        <th style={{width:"15%"}}>EMPLOYEE NAME</th>
                        <th style={{width:"15%"}}>VALIDATOR</th>
                        <th style={{width:"15%"}}>TITLE </th>
                        <th style={{width:"10%"}}>ACTION</th>
                        <th style={{width:"10%"}}>CREATED AT</th>
                        <th style={{width:"10%"}}>ACCEPTED AT</th>
                    </tr>
                </thead>

                <tbody className="text-white" style={{ fontSize: "small" }}>
                    {filteredRecords.length > 0 ? (
                        filteredRecords.map((sub, index) => (
                            <tr key={sub.id}>

                                <td>{index + 1}</td>
                                <td>{sub.id}</td>
                                <td>{sub.empid}</td>
                                <td>{sub.empname}</td>
                                <td>{sub.validatorname}</td>
                                <td>{sub.title}</td>

                                <td>
                                    <div className="d-flex justify-content-center fw-bold" style={{ fontSize: "18px" }}>
                                            <i class="bi bi-eye-fill" style={{ color: "blue", cursor: "pointer" }} title="See" onClick={() => handleOpenSeeModal(sub)}></i>
                                    </div>

                                </td>

                                <td>
                                    {new Date(sub.createdat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td>

                                <td>
                                    {new Date(sub.lastupdatedat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" style={{ textAlign: "center" }}>
                                No accepts came from approver...
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <Modal
                show={showSeeModal}
                onHide={handleCloseSeeModal}
                backdrop="static"
                keyboard={false}
                fullscreen
            >
                <ApproverSeePage userDetails={userDetails} isApproved={isApproved} handleCloseSeeModal={handleCloseSeeModal} setParentLoading={setParentLoading} />
            </Modal>

        </div>
    );
}

export default ApproverAccepted;